define('viewmodels/ActionTracker/AssignActionItems',['knockout', 'plugins/router', 'durandal/app', 'services/appsecurity', 'services/navigation', 'durandal/system', 'services/logger', 'services/utils'], function (ko, router, app, appsecurity, navigation, system, logger, utils) {
    var ActionItemDashboardVM = { title: ko.observable("Action Item Dashboard"),
        attached: attached,
        activate: activate,
        appsecurity: appsecurity,
        logger: logger,
        utils: utils,
        AssignAssignees: AssignAssignees,
        AssignReviewers: AssignReviewers,
        AssignBulkAssignees: AssignBulkAssignees,
        AssignBulkReviewers: AssignBulkReviewers,
        ActionChangedUserAssignment: ActionChangedUserAssignment,
        ActionItemModelList: ko.observableArray([]),
        SelectedActionIdList: ko.observableArray([]),
        L1ActionItemUsersList: ko.observableArray([]),
        L2ActionItemUsersList: ko.observableArray([]),
        ActionItemUsersList: ko.observableArray([]),
        SelectedUserType: ko.observable(),
        popUpTitleSurvey: ko.observable(),
        CloseMappingPopUp: CloseMappingPopUp,
        SelectAllActionItems: SelectAllActionItems,
        SaveUserMapping: SaveUserMapping,
        SaveMappingPopUp: SaveMappingPopUp,
        SelectAllUsers: SelectAllUsers,
        DisableActionButtons: ko.observable(),
        ShowControlQuestion: ShowControlQuestion,
        popUpTitleQuestion: ko.observable(),
        AIMControlQuestion: ko.observable(),
        AIMTitleFull: ko.observable(),
        AIMTitle: ko.observable(),
        closePopup: closePopup,
        SelectedPeriodOfAssessment: ko.observableArray([]),
        PeriodOfAssessmentList: ko.observableArray([]),
        AssessmentTypeList: ko.observableArray([]),
        SelectedAssessmentType: ko.observableArray([]),
        FilterControlArea: ko.observable(),
        ActionOrgLevelList: ko.observableArray([]),
        SelectedActionOrgLevels: ko.observableArray([]),
        ActionSubOrgLevelList: ko.observableArray([]),
        SelectedSubOrgLevel: ko.observableArray([]),
        ActionBusinessUnitList: ko.observableArray([]),
        SelectedBusinessUnitList: ko.observable([]),
        LoadDropDownvalues: LoadDropDownvalues,
        DropDownValues: ko.observable(),
        PeriodOfAssessmentSelected: PeriodOfAssessmentSelected,
        AssessmentTypeSelected: AssessmentTypeSelected,
        ClearSelection: ClearSelection,
        ApplyFilter: ApplyFilter
       // ClearFilteredData: ClearFilteredData
    };
    return ActionItemDashboardVM;

    function activate() {
        try {

        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | activate() in AssignActionItems.js';
            logger.logMessage(msg);
        }
    };

    function attached() {
        try {
            GetAllActionItems();
            //LoadDropDownvalues();
            $('#LoadingImgMain').show();

            $('#TableAssignActionItems').hide();
            $('#SelectFilterOrganizationLevel').multiselect();
            $('#SelectFilterSubIrganizationLevel').multiselect();
            $('#SelectFilterBusinessUnit').multiselect();

            $('#tblactiondetails').DataTable().state.clear();
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | attached() in AssignActionItems.js';
            logger.logMessage(msg);
        }
    };

    function LoadDropDownvalues() {
        try {
            return $.ajax({
                url: "/api/ActionPlan/GetAllDropdownValues",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(function (jsonResult, error) {
                    ActionItemDashboardVM.PeriodOfAssessmentList([]);
                    if (jsonResult != null) {
                        var MappedPeriodOfAssessmentList = $.map(jsonResult.OrgLevelListModelObject, function (result) {
                            return new AssessmentPeriodModel(result);
                        });
                        var filteredIdsList = [];
                        var filteredList = [];
                        for (var i = 0, j = MappedPeriodOfAssessmentList.length; i < j; i++) {
                            if (ko.utils.arrayIndexOf(filteredIdsList, MappedPeriodOfAssessmentList[i].ASSESSMENT_PROFILE_APD_UID) < 0) {
                                filteredIdsList.push(MappedPeriodOfAssessmentList[i].ASSESSMENT_PROFILE_APD_UID);
                                filteredList.push(MappedPeriodOfAssessmentList[i]);
                            }
                        }
                        ActionItemDashboardVM.DropDownValues(jsonResult);
                        ActionItemDashboardVM.PeriodOfAssessmentList(filteredList);
                        ActionItemDashboardVM.SelectedPeriodOfAssessment([]);                      
                        $('#LoadingFilterAssessmentType').hide();
                        $('#LoadingFilterSubIrganizationLevel').hide();
                        $('#LoadingFilterBusinessUnit').hide();
                    }
                })
                .fail(function (jsonResult, error) {
                    $('#LoadingFilterPeriodOfAssessment').hide();
                    logger.logError('An error has occurred while fetching the Filter values. Please contact your Administrator.', 'Error', system.getModuleId(ActionItemDashboardVM), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: LoadDropDownvalues() method in AssignActionItems.js';
            logger.logMessage(msg);
        }
    }

    function PeriodOfAssessmentSelected() {
        try {
            $('#LoadingFilterAssessmentType').show();
            
            
            var filteredIdsList = [];
            var filteredList = [];
            for (var i = 0; i < ActionItemDashboardVM.DropDownValues().OrgLevelListModelObject.length; i++) {
                if ((ko.utils.arrayIndexOf(this.SelectedPeriodOfAssessment(), ActionItemDashboardVM.DropDownValues().OrgLevelListModelObject[i].ProfileId) >= 0)
                    && (ko.utils.arrayIndexOf(filteredIdsList, ActionItemDashboardVM.DropDownValues().OrgLevelListModelObject[i].AssessmentId) < 0)) {
                    filteredIdsList.push(ActionItemDashboardVM.DropDownValues().OrgLevelListModelObject[i].AssessmentId);
                    filteredList.push(ActionItemDashboardVM.DropDownValues().OrgLevelListModelObject[i]);
                }
               
            }

            var MappedAssessmentTypeList = $.map(filteredList, function (result) {
                return new AssessmentTypeModel(result);
            });

            ActionItemDashboardVM.AssessmentTypeList(MappedAssessmentTypeList);

            ActionItemDashboardVM.SelectedAssessmentType([]);
            $('#SelectFilterAssessmentType').multiselect("refresh");
            $('#LoadingFilterPeriodOfAssessment').hide();
            $('#LoadingFilterAssessmentType').hide();

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: PeriodOfAssessmentSelected() method in AssignActionItems.js';
            logger.logMessage(msg);
            $('#LoadingFilterPeriodOfAssessment').hide();
            $('#LoadingFilterAssessmentType').hide();
        }
        finally {

        }
    }
    function AssessmentTypeSelected() {
        try {
            $('#LoadingFilterSubIrganizationLevel').show();
            $('#LoadingFilterBusinessUnit').show();
            FillOrgLevelDropDown();
            FillCompleteSubOrglevelList();
            FillCompleteBuList();
            
            //FillControlAreaDropDown();
           
            
            $("#btnSelectFilteredData").show();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AssessmentTypeSelected() method in ConfigureActionTracker.js';
            logger.logMessage(msg);
        }
        finally {
           
        }
    }

    function FillOrgLevelDropDown() {
        try {
            var filteredIdsList = [];
            var filteredList = [];
            for (var i = 0; i < ActionItemDashboardVM.DropDownValues().OrgLevelListModelObject.length; i++) {
                if ((ko.utils.arrayIndexOf(ActionItemDashboardVM.SelectedPeriodOfAssessment(), ActionItemDashboardVM.DropDownValues().OrgLevelListModelObject[i].ProfileId) >= 0)
                    && (ko.utils.arrayIndexOf(ActionItemDashboardVM.SelectedAssessmentType(), ActionItemDashboardVM.DropDownValues().OrgLevelListModelObject[i].AssessmentId) >= 0)
                    && (ko.utils.arrayIndexOf(filteredIdsList, ActionItemDashboardVM.DropDownValues().OrgLevelListModelObject[i].OrgLevelId) < 0)) {
                    filteredIdsList.push(ActionItemDashboardVM.DropDownValues().OrgLevelListModelObject[i].OrgLevelId);
                    filteredList.push(ActionItemDashboardVM.DropDownValues().OrgLevelListModelObject[i]);
                }
            }

            var MappedOrgLevelList = $.map(filteredList, function (result) {
                return new OrgLevelModel(result);
            });

            ActionItemDashboardVM.ActionOrgLevelList(MappedOrgLevelList);

            ActionItemDashboardVM.SelectedActionOrgLevels([]);
            $('#SelectFilterOrganizationLevel').multiselect();
            $('#SelectFilterOrganizationLevel').multiselect("refresh");
            
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: FillOrgLevelDropDown() method in ConfigureActionTracker.js';
            logger.logMessage(msg);
        }
    }

    function FillCompleteSubOrglevelList() {
        var filteredIdsList = [];
        var filteredList = [];
        for (var i = 0; i < ActionItemDashboardVM.DropDownValues().OrgLevelListModelObject.length; i++) {
            if ((ko.utils.arrayIndexOf(ActionItemDashboardVM.SelectedPeriodOfAssessment(), ActionItemDashboardVM.DropDownValues().OrgLevelListModelObject[i].ProfileId) >= 0)
                && (ko.utils.arrayIndexOf(ActionItemDashboardVM.SelectedAssessmentType(), ActionItemDashboardVM.DropDownValues().OrgLevelListModelObject[i].AssessmentId) >= 0)
                && (ko.utils.arrayIndexOf(filteredIdsList, ActionItemDashboardVM.DropDownValues().OrgLevelListModelObject[i].SubOrgLevelId) < 0)) {
                filteredIdsList.push(ActionItemDashboardVM.DropDownValues().OrgLevelListModelObject[i].SubOrgLevelId);
                filteredList.push(ActionItemDashboardVM.DropDownValues().OrgLevelListModelObject[i]);
            }
        }

        var MappedSubOrgLevelList = $.map(filteredList, function (result) {
            return new SubOrgLevelModel(result);
        });

        ActionItemDashboardVM.ActionSubOrgLevelList(MappedSubOrgLevelList);

        ActionItemDashboardVM.SelectedSubOrgLevel([]);
        $('#SelectFilterSubIrganizationLevel').multiselect();
        $('#SelectFilterSubIrganizationLevel').multiselect("refresh");
        $('#LoadingFilterSubIrganizationLevel').hide();
       
    }

    function FillCompleteBuList() {
        var filteredIdsList = [];
        var filteredList = [];
        for (var i = 0; i < ActionItemDashboardVM.DropDownValues().OrgLevelListModelObject.length; i++) {
            if ((ko.utils.arrayIndexOf(ActionItemDashboardVM.SelectedPeriodOfAssessment(), ActionItemDashboardVM.DropDownValues().OrgLevelListModelObject[i].ProfileId) >= 0)
                && (ko.utils.arrayIndexOf(ActionItemDashboardVM.SelectedAssessmentType(), ActionItemDashboardVM.DropDownValues().OrgLevelListModelObject[i].AssessmentId) >= 0)
                && (ko.utils.arrayIndexOf(filteredIdsList, ActionItemDashboardVM.DropDownValues().OrgLevelListModelObject[i].BuId) < 0)) {
                filteredIdsList.push(ActionItemDashboardVM.DropDownValues().OrgLevelListModelObject[i].BuId);
                filteredList.push(ActionItemDashboardVM.DropDownValues().OrgLevelListModelObject[i]);
            }
        }


        var MappedBUList = $.map(filteredList, function (result) {
            return new BUModel(result);
        });

        ActionItemDashboardVM.ActionBusinessUnitList(MappedBUList);

        ActionItemDashboardVM.SelectedBusinessUnitList([]);
        $('#SelectFilterBusinessUnit').multiselect();
        $('#SelectFilterBusinessUnit').multiselect("refresh");
        $('#LoadingFilterBusinessUnit').hide();

    }

    
    function ClearSelection() {
        try {
           
            $('#txtFilterControlArea').val("");
            ActionItemDashboardVM.SelectedPeriodOfAssessment([]);
            ActionItemDashboardVM.SelectedAssessmentType([]);
            ActionItemDashboardVM.SelectedActionOrgLevels([]);
            ActionItemDashboardVM.SelectedSubOrgLevel([]);
            ActionItemDashboardVM.SelectedBusinessUnitList([]);
            ActionItemDashboardVM.ActionBusinessUnitList([]);
            ActionItemDashboardVM.ActionSubOrgLevelList([]);
            ActionItemDashboardVM.ActionOrgLevelList([]);
            ActionItemDashboardVM.AssessmentTypeList([]);
            $("#SelectFilterOrganizationLevel").multiselect("refresh");
            $("#SelectFilterSubIrganizationLevel").multiselect("refresh");
            $("#SelectFilterBusinessUnit").multiselect("refresh");
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ClearSelection() method in AssignActionItem.js';
            logger.logMessage(msg);
        }
    }
    function ApplyFilter() {
        try {


        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ApplyFilter() method in AssignActionItem.js';
            logger.logMessage(msg);
        }
    }
    function SelectAllUsers(data, event) {
        try {
            var rows = $("#MappingTable").dataTable().fnGetNodes();
            var cells = [];
            for (var i = 0; i < rows.length; i++) {
                if (event.currentTarget.checked == true)

                    $(rows[i]).find("td:eq(1)").find('input').prop("checked", true);
                else
                    $(rows[i]).find("td:eq(1)").find('input').prop("checked", false);
            }
            for (var j = 0; j < ActionItemDashboardVM.ActionItemUsersList().length; j++)
            {
                if (event.currentTarget.checked == true)
                    ActionItemDashboardVM.ActionItemUsersList()[j].IsChecked(true);
                else
                    ActionItemDashboardVM.ActionItemUsersList()[j].IsChecked(false);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in SelectAllUsers() method in AssignActionItems.js';
            logger.logMessage(msg);
        }
    }
    function SaveUserMapping(data, event) {
        try {
            SaveMappingPopUp();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:SaveUserMapping() method in AssignActionItems.js';
            logger.logMessage(msg);
        }
    }
    function SaveMappingPopUp() {
        try {
            var MappedUserList = generateJsonUsers()
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            return $.ajax({
                url: "/api/ActionPlan/SaveActionItemAssignment",
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(MappedUserList)
            })
.success(function (jsonResult, success) {
    if (jsonResult > 0) {
        logger.logSuccess('Action Item User Mapping has been saved successfully.', 'Success', system.getModuleId(ActionItemDashboardVM), true);
        $('#ActionItemAssignment').modal('hide');
        GetAllActionItems();
    }
    else {
        logger.logError('An error has occurred while saving User Mapping. Please contact your Administrator.', 'Error', system.getModuleId(ActionItemDashboardVM), true);
    }
})
.fail(function (jsonResult, error) {

})
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:SaveMappingPopUp() method in AssignActionItems.js';
            logger.logMessage(msg);
        }
    }

    function generateJsonUsers() {
        try {
            var MainList = [];
            for (var i = 0; i < ActionItemDashboardVM.SelectedActionIdList().length; i++) {
                var mappedlist = $.map(ActionItemDashboardVM.ActionItemUsersList(), function (item) {
                    if (item.IsChecked())
                        return { AIM_UID: ActionItemDashboardVM.SelectedActionIdList()[i], ROLE_ID: item.RoleId(), ROLE_TYPE: item.RoleType(), USER_ID: item.UserId() };
                });
                var x = "temp";
                for (var j = 0; j < mappedlist.length; j++) {
                    MainList.push(mappedlist[j]);
                }
            }
            return MainList

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:generateJsonUsers() method in AssignActionItems.js';
            logger.logMessage(msg);
        }
    }
    function ShowControlQuestion(data, event) {
        try {
            ActionItemDashboardVM.popUpTitleQuestion("View Control Question");
            ActionItemDashboardVM.AIMControlQuestion(data.AIMControlQuestion());
            ActionItemDashboardVM.AIMTitleFull(data.AIMTitleFull());
            ActionItemDashboardVM.AIMTitle(data.AIMTitle());
            $('#ViewControlQuestion').modal('show');
           

            
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ShowControlQuestion() method in AssignActionItems.js';
            logger.logMessage(msg);
        }
    }
    function closePopup(data, event) {
        try {
            ActionItemDashboardVM.AIMControlQuestion('');
            ActionItemDashboardVM.AIMTitleFull('');
            ActionItemDashboardVM.AIMTitle('');
            $('#ViewControlQuestion').modal('hide');



        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: closePopup() method in AssignActionItems.js';
            logger.logMessage(msg);
        }
    }
    function AssignAssignees(data, event) {
        try {
            $('#ValErrorSurvey').hide();
            $("#PopupBody").show();
            ActionItemDashboardVM.SelectedActionIdList([]);
            ActionItemDashboardVM.SelectedActionIdList().push(data.ActionId())
            ActionItemDashboardVM.SelectedUserType("AI_ASG")
            ActionItemDashboardVM.popUpTitleSurvey('Assign Users')
            $('#ActionItemAssignment').modal('show');
            $('#modalContent').css({
                'margin-top': '25%'
            });
            var object = $('#MappingTable').DataTable();

            object.destroy();
            $("#MappingTable tbody tr").remove();

            GetRespondents(data.ActionId).then(function () {
                ActionChangedUserAssignment();

            })
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AssignAssignees() method in AssignActionItems.js';
            logger.logMessage(msg);
        }
    }
    function AssignReviewers(data, event) {
        try {
            $('#ValErrorSurvey').hide();
            $("#PopupBody").show();
            ActionItemDashboardVM.SelectedActionIdList([]);
            ActionItemDashboardVM.SelectedActionIdList().push(data.ActionId())
            ActionItemDashboardVM.SelectedUserType("AI_REV")

            ActionItemDashboardVM.popUpTitleSurvey('Assign Users')
            $('#ActionItemAssignment').modal('show');
            $('#modalContent').css({
                'margin-top': '25%'
            });
            var object = $('#MappingTable').DataTable();

            object.destroy();
            $("#MappingTable tbody tr").remove();

            GetRespondents(data.ActionId).then(function () {
                ActionChangedUserAssignment();

            })
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AssignReviewers() method in AssignActionItems.js';
            logger.logMessage(msg);
        }
    }
    function ActionChangedUserAssignment() {
        try {
            if (ActionItemDashboardVM.SelectedUserType() == 'AI_ASG') {
                ActionItemDashboardVM.ActionItemUsersList([]);
                var MappedL1List = $.map(ActionItemDashboardVM.L1ActionItemUsersList(), function (result) {
                    return new L1RespondentListModel(result);
                });
                ActionItemDashboardVM.ActionItemUsersList(MappedL1List);
                $('#MappingTable').DataTable();
            }
            else {
                ActionItemDashboardVM.ActionItemUsersList([]);
                var MappedL1List = $.map(ActionItemDashboardVM.L2ActionItemUsersList(), function (result) {
                    return new L1RespondentListModel(result);
                });
                ActionItemDashboardVM.ActionItemUsersList(MappedL1List);
                $('#MappingTable').DataTable();
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ActionChangedUserAssignment() method in AssignActionItems.js';
            logger.logMessage(msg);
        }
    }

    function GetRespondents(ActionId) {
        try {
            return $.ajax({
                url: "/api/ActionPlan/GetActionItemUsers",
                type: "GET",
                data: { "ActionId": ActionId },
                headers: appsecurity.getSecurityHeaders()
            })
             .success(function (jsonResult, Success) {
                 if (jsonResult != null) {
                     var MappedL1List = $.map(jsonResult, function (result) {
                         if (result.RoleType == 'AI_ASG')
                             return new L1RespondentListModel(result);
                     });
                     //ActionItemDashboardVM.L1SurveyUsersList(MappedL1List);
                     var MappedL2List = $.map(jsonResult, function (result) {
                         if (result.RoleType == 'AI_REV')
                             return new L1RespondentListModel(result);
                     });

                     ActionItemDashboardVM.L1ActionItemUsersList([]);
                     ActionItemDashboardVM.L2ActionItemUsersList([])
                     ActionItemDashboardVM.L1ActionItemUsersList(MappedL1List);
                     ActionItemDashboardVM.L2ActionItemUsersList(MappedL2List);
                 }
             })
             .fail(function (jsonResult, error) {
                 logger.logError('An error has occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ActionItemDashboardVM), true);

             });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetRespondents() method in AssignActionItems.js';
            logger.logMessage(msg);
        }
    }

    function GetAllActionItems() {
        try {
            return $.ajax({
                url: "/api/ActionPlan/GetAllAssignActionItems",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
    .success(function (jsonResult, success) {
        if (jsonResult == null) {
            ActionItemDashboardVM.ActionItemModelList([]);
         
        }
        else if (jsonResult.length >= 0) {
            var mappedActionListgroup = $.map(jsonResult, function (result) {
                var ActionItemModelObj = new ActionItemUnitModel(result);
                return ActionItemModelObj;
            });

            $('#LoadingImgMain').hide();
            $('#TableAssignActionItems').show();
            var object = $('#tblactiondetails').DataTable();
            ActionItemDashboardVM.ActionItemModelList([]);
            object.destroy();
            $('#tblactiondetails tbody tr').remove();

            ActionItemDashboardVM.ActionItemModelList(mappedActionListgroup);
            $("#tblactiondetails").DataTable({
                stateSave: true,
                bAutoWidth: false, // Disable the auto width calculation 
                bSortClasses: false,
                bDeferRender: true,
                bpaginate: "full_numbers",
                iDisplayLength: 10,
                bLengthChange: true
                
            });
            $('#tblactiondetails').dataTable().columnFilter({
                sPlaceHolder: 'footer:before',
                aoColumns: [null,
                    null,
                { type: "select" },
                { type: "select" },
                { type: "select" },
                { type: "select" },
                { type: "select" },
                null,
                { type: "select" }
                ]
            });
            var rows = $("#tblactiondetails").dataTable().fnGetNodes();
            var cells = [];
            for (var i = 0; i < rows.length; i++) {
                // Get HTML of 3rd column (for example)
                var RespText = $(rows[i]).find("td:eq(9)").html()
                var RespTextEdit = RespText.replace(/}/g, '<br/>');
                $(rows[i]).find("td:eq(9)").html(RespTextEdit);
                var RevText = $(rows[i]).find("td:eq(11)").html()
                var RevTextEdit = RevText.replace(/}/g, '<br/>');
                $(rows[i]).find("td:eq(11)").html(RevTextEdit);
                if ($(rows[i]).find("td:eq(9)").text().toUpperCase() == 'UNASSIGNED') {
                    if ($(rows[i]).find("td:eq(9)") != null && $(rows[i]).find("td:eq(9)") != undefined) {
                        $(rows[i]).find("td:eq(9)").css('color', '#FF0000');
                    }
                }
                if ($(rows[i]).find("td:eq(11)").text().toUpperCase() == 'UNASSIGNED') {
                    if ($(rows[i]).find("td:eq(11)") != null && $(rows[i]).find("td:eq(11)") != undefined) {
                        $(rows[i]).find("td:eq(11)").css('color', '#FF0000');
                    }
                }

            }
        }
    })

    .fail(function (jsonnResult, error) {

        logger.logError('An error has occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ActionItemDashboardVM), true);

    });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetAllActionItems() method in AssignActionItems.js';
            logger.logMessage(msg);
        }
    }


    function CloseMappingPopUp(data, event) {
        try {
            $('#ActionItemAssignment').modal('hide');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CloseMappingPopUp() method in AssignActionItems.js';
            logger.logMessage(msg);
        }
    }


    function GetAssignees(ActionItemId) {
        try {
            return $.ajax({
                url: "/api/ActionPlan/GetActionItemUsers",
                type: "GET",
                data: {  "ActionitemId": ActionItemId },
                headers: appsecurity.getSecurityHeaders()
            })
             .success(function (jsonResult, Success) {
                 if (jsonResult != null) {
                     var MappedL1List = $.map(jsonResult, function (result) {
                         if (result.RoleType == 'AI_ASG')
                             return new L1RespondentListModel(result);
                     });
                     //SCViewModel.L1SurveyUsersList(MappedL1List);
                     var MappedL2List = $.map(jsonResult, function (result) {
                         if (result.RoleType == 'AI_REV')
                             return new L1RespondentListModel(result);
                     });

                     ActionItemDashboardVM.L1SurveyUsersList([]);
                     ActionItemDashboardVM.L2SurveyUsersList([])
                     ActionItemDashboardVM.L1SurveyUsersList(MappedL1List);
                     ActionItemDashboardVM.L2SurveyUsersList(MappedL2List);
                 }
             })
             .fail(function (jsonResult, error) {
                 logger.logError('An error has occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);

             });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetAssignees() method in AssignActionItems.js';
            logger.logMessage(msg);
        }
    }


    function SelectAllActionItems(data, event) {
        try {
            if (event.currentTarget.checked) {
                for (var i = 0 ; i < ActionItemDashboardVM.ActionItemModelList().length; i++) {
                    ActionItemDashboardVM.ActionItemModelList()[i].isChecked(event.currentTarget.checked);
                }
            }
            else {
                for (var i = 0 ; i < ActionItemDashboardVM.ActionItemModelList().length; i++) {
                    ActionItemDashboardVM.ActionItemModelList()[i].isChecked(event.currentTarget.checked);
                }
            }
            var rows = $("#tblactiondetails").dataTable().fnGetNodes();
            var cells = [];
            for (var i = 0; i < rows.length; i++) {
                if (event.currentTarget.checked == true)
                    $(rows[i]).find("td:eq(0)").find('input').prop("checked", true);
                else
                    $(rows[i]).find("td:eq(0)").find('input').prop("checked", false);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SelectAllActionItems() method in AssignActionItems.js';
            logger.logMessage(msg);
        }
    }

    function AssignBulkAssignees() {
        try {
            ActionItemDashboardVM.DisableActionButtons(false);
            ActionItemDashboardVM.popUpTitleSurvey('Assign Assignees')
            ActionItemDashboardVM.SelectedActionIdList([])
            for (var i = 0; i < ActionItemDashboardVM.ActionItemModelList().length; i++) {
                if (ActionItemDashboardVM.ActionItemModelList()[i].isChecked()) {
                    ActionItemDashboardVM.SelectedActionIdList().push(ActionItemDashboardVM.ActionItemModelList()[i].ActionId());
                }
            }
            ActionItemDashboardVM.SelectedUserType("AI_ASG")
            $('#ActionItemAssignment').modal('show');
            $('#selectallUsers').prop('checked', false);
            $('#modalContent').css({
                'margin-top': '25%'
            });
            if (ActionItemDashboardVM.SelectedActionIdList().length == 0) {
                $('#ValErrorSurvey').show();
                $("#PopupBody").hide();
                $('#ValErrorSurvey').html('None of the Action Items have been selected to perform the group actions');
                ActionItemDashboardVM.DisableActionButtons(true);
            }
            else {
                $('#ValErrorSurvey').hide();
                $("#PopupBody").show();
                var object = $('#MappingTable').DataTable();

                object.destroy();
                $("#MappingTable tbody tr").remove();

                GetAllAssignees(ActionItemDashboardVM.SelectedUserType()).then(function () {


                })
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:AssignBulkAssignees() method in AssignActionItems.js';
            logger.logMessage(msg);
        }
    }
    function AssignBulkReviewers() {
        try {
            ActionItemDashboardVM.popUpTitleSurvey('Assign Reviewers')
            ActionItemDashboardVM.SelectedActionIdList([])
            for (var i = 0; i < ActionItemDashboardVM.ActionItemModelList().length; i++) {
                if (ActionItemDashboardVM.ActionItemModelList()[i].isChecked()) {
                    ActionItemDashboardVM.SelectedActionIdList().push(ActionItemDashboardVM.ActionItemModelList()[i].ActionId());
                }
            }

            ActionItemDashboardVM.SelectedUserType("AI_REV")
            $('#ActionItemAssignment').modal('show');
            $('#selectallUsers').prop('checked', false);
            $('#modalContent').css({
                'margin-top': '25%'
            });
            if (ActionItemDashboardVM.SelectedActionIdList().length == 0) {
                $('#ValErrorSurvey').show();
                $("#PopupBody").hide();
                $('#ValErrorSurvey').html('None of the Action Items have been selected to perform the group actions');
                ActionItemDashboardVM.DisableActionButtons(true);
            }
            else {
                $('#ValErrorSurvey').hide();
                $("#PopupBody").show();
                var object = $('#MappingTable').DataTable();

                object.destroy();
                $("#MappingTable tbody tr").remove();

                GetAllAssignees(ActionItemDashboardVM.SelectedUserType()).then(function () {

                })
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:AssignBulkReviewers() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function AssessmentPeriodModel(item) {
        try {
            var self = this;
            self.ASSESSMENT_PERIOD_ID = ko.observable(item.ProfileId);
            self.ASSESSMENT_NAME = ko.observable(item.ProfileName);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AssessmentPeriodModel() method in AssignActionItems.js';
            logger.logMessage(msg);
        }
    }
    function AssessmentTypeModel(item) {
        try {
            var self = this;
            self.ASSESSMENT_TYPE_ID = ko.observable(item.AssessmentId);
            self.ASSESSMENT_TYPE = ko.observable(item.AssessmentType);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AssessmentTypeModel() method in ConfigureActionTracker.js';
            logger.logMessage(msg);
        }
    }
    function OrgLevelModel(item) {
        try {
            var self = this;
            self.ORG_LEVEL_ID = ko.observable(item.OrgLevelId);
            self.ORG_LEVEL = ko.observable(item.OrgLevelname);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OrgLevelModel() method in ConfigureActionTracker.js';
            logger.logMessage(msg);
        }
    }

    function SubOrgLevelModel(item) {
        try {
            var self = this;
            self.SUBORG_LEVEL_ID = ko.observable(item.SubOrgLevelId);
            self.SUBORG_LEVEL = ko.observable(item.SubOrgLevelName);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SubOrgLevelModel() method in ConfigureActionTracker.js';
            logger.logMessage(msg);
        }
    }

    function BUModel(item) {
        try {
            var self = this;
            self.BUSINESS_UNIT_ID = ko.observable(item.BuId);
            self.BUSINESS_UNIT = ko.observable(item.BuName);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BUModel() method in ConfigureActionTracker.js';
            logger.logMessage(msg);
        }
    }



    function GetAllAssignees(RoleType) {
        try {
            return $.ajax({
                url: "/api/ActionPlan/GetALLActionItemUsers",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                           .success(function (jsonResult, Success) {
                               var MappedList = $.map(jsonResult, function (result) {
                                   if (result.RoleType == RoleType)
                                       return new L1RespondentListModel(result);
                               });
                               ActionItemDashboardVM.ActionItemUsersList(MappedList);
                               $('#MappingTable').DataTable();
                           })
            .fail(function (jsonResult, error) {
                logger.logError('An error has occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ActionItemDashboardVM), true);
            })
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetAllAssignees() method in AssignActionItems.js';
            logger.logMessage(msg);
        }
    }

    function ActionItemUnitModel(item) {
        try {
            var self = this;
            self.ActionId = ko.observable(item.AIM_UID);
            self.AIMTitle = ko.observable(item.AIM_TITLE);
            self.AIMTitleFull = ko.observable(item.AIM_TITLE_FULL);
            self.AIMAssessmentProfile = ko.observable(item.AIM_ASSESSMENT_PROFILE);
            self.AIMAssessmentType = ko.observable(item.AIM_ASSESSMENT_TYPE);
            self.AIMBUName = ko.observable(item.AIM_BU_NAME);
            self.AIMControlArea = ko.observable(item.AIM_CONTROL_AREA);
            self.AIMControlQuestion = ko.observable(item.AIM_CONTROL_QUESTION);
            self.AIMControlResponse = ko.observable(item.AIM_CONTROL_RESPONSE);
            self.L1UserList = ko.observable($('<div/>').html(item.L1_USER_LIST).text());
            self.L2UserList = ko.observable($('<div/>').html(item.L2_USER_LIST).text());
            self.isChecked = ko.observable(false);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ActionItemUnitModel() method in AssignActionItems.js';
            logger.logMessage(msg);
        }
    }


    function L1RespondentListModel(item) {
        try {
            var self = this;
            if (item.UserName.length > 0)
                self.UserName = ko.observable(item.UserName);
            else
                self.UserName = ko.observable(item.UserName());
            if (item.Role.length > 0)
                self.Role = ko.observable(item.Role);
            else
                self.Role = ko.observable(item.Role());
            if (!isNaN(item.UserId))
                self.UserId = ko.observable(item.UserId);
            else
                self.UserId = ko.observable(item.UserId());
            if (item.RoleType.length > 0)
                self.RoleType = ko.observable(item.RoleType);
            else
                self.RoleType = ko.observable(item.RoleType());
            if (typeof (item.IsChecked) === "boolean")
                self.IsChecked = ko.observable(item.IsChecked);
            else
                self.IsChecked = ko.observable(item.IsChecked());
            if (!isNaN(item.RoleId))
                self.RoleId = ko.observable(item.RoleId);
            else
                self.RoleId = ko.observable(item.RoleId());

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: L1RespondentListModel() method in AssignActionItems.js';
            logger.logMessage(msg);
        }
    }
});
